import { render, staticRenderFns } from "./TablePutAway.vue?vue&type=template&id=4d76b0d5&"
import script from "./TablePutAway.vue?vue&type=script&lang=js&"
export * from "./TablePutAway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports